module.exports = __webpack_public_path__ + "img/attestation_geek_finish.7b7924cd.png";